const steps = [
  { n: "01", t: "Diagnóstico", d: "Mapeamos objetivos comerciais, público B2B, concorrência e oportunidades de SEO." },
  { n: "02", t: "Estratégia", d: "Definimos arquitetura, copy, jornadas e prioridades para gerar leads qualificados." },
  { n: "03", t: "Desenvolvimento", d: "Construímos sites, aplicações e integrações com código limpo, rápido e escalável." },
  { n: "04", t: "Lançamento", d: "Validamos performance, SEO técnico, analytics e deploy sem fricção." },
  { n: "05", t: "Evolução", d: "Acompanhamos métricas, melhorias e novas funcionalidades para a operação crescer." },
];

const Process = () => {
  return (
    <section
      id="processo"
      data-testid="process-section"
      className="bg-[#0a0a0a] py-24 md:py-32 relative overflow-hidden"
    >
      <div className="absolute top-1/2 right-0 w-72 h-72 bg-[#ff6b35] opacity-10 rounded-full blur-3xl" />

      <div className="max-w-[1200px] mx-auto px-5 sm:px-8">
        <div className="text-center mb-20 vc-reveal">
          <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-4">
            ✦ Como trabalhamos
          </div>
          <h2 className="font-display text-white text-5xl sm:text-7xl uppercase leading-[0.9]">
            Processo <span className="text-[#ff6b35]">B2B.</span>
          </h2>
        </div>

        <div className="relative">
          {/* dashed connector */}
          <div
            className="absolute left-10 md:left-1/2 top-0 bottom-0 w-[3px] hidden sm:block"
            style={{
              backgroundImage:
                "repeating-linear-gradient(to bottom, #ff6b35 0 12px, transparent 12px 22px)",
            }}
          />

          <div className="space-y-10">
            {steps.map((s, i) => {
              const right = i % 2 === 1;
              return (
                <div
                  key={s.n}
                  data-testid={`process-step-${i}`}
                  className={`vc-reveal flex flex-col sm:flex-row items-start gap-6 ${
                    right ? "sm:flex-row-reverse" : ""
                  }`}
                >
                  <div className="hidden sm:flex w-1/2" />
                  <div className="hidden sm:block relative">
                    <div className="absolute left-1/2 -translate-x-1/2 top-6 w-6 h-6 bg-[#ff6b35] brutal-border" />
                  </div>
                  <div className="w-full min-w-0 sm:w-1/2">
                    <div className="bg-[#ff6b35] brutal-border-thick brutal-shadow p-6">
                      <div className="flex min-w-0 items-baseline gap-3 sm:gap-4">
                        <span className="font-display text-white text-5xl shrink-0">{s.n}</span>
                        <h3 className="font-display text-[#0a0a0a] text-xl sm:text-2xl uppercase break-words">
                          {s.t}
                        </h3>
                      </div>
                      <p className="text-white text-base mt-3">{s.d}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
